export default {
    data() {
        return {
            app: window.app
        }
    },
    methods: {
        rgbToHex(rgb) {
            return '#' + rgb.map(x => {
                const hex = x.toString(16)
                return hex.length === 1 ? '0' + hex : hex
            }).join('')
        }
    }
}
